import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable()
export class GeneralEventsService {
  public sideBardCollapsEnd: Observable<boolean>;
  private _sideBardCollapsStart$ = new Subject<boolean>();
  private _isSidebarOpen$ = new BehaviorSubject(true);
  private _isRotorTypeCreated$ = new BehaviorSubject(false);

  get sidebarOpen$(): Observable<boolean> {
    return this._isSidebarOpen$.asObservable();
  }

  get isRotorTypeCreated$(): Observable<boolean> {
    return this._isRotorTypeCreated$.asObservable();
  }

  constructor() {
    this.sideBardCollapsEnd = this._sideBardCollapsStart$.pipe(delay(260));
  }

  public toggleSidebar(value: boolean): void {
    this._sideBardCollapsStart$.next(value);
    this._isSidebarOpen$.next(value);
  }

  public setRotorTypeCreated(value: boolean): void {
    this._isRotorTypeCreated$.next(value);
  }
}
